export const sidebarRoutes = [
    "/gestione-corsi",
    "/area-personale/corsi",
    "/area-personale/corso",
    "/area-personale/classi",
    "/area-personale/classe",
    "/area-personale/ticket",
    "/area-personale/voucher",
    "/area-personale/calendario/esami",
    "/area-personale/calendario/lezioni",
    "/crea-corso",
    "/aggiungi-contenuti",
    "/configura-lezioni",
    "/configura-esami",
    "/gestione-risultati-esame",
    "/configura-argomenti",
    "/registro-presenze",
    "/gestione-classi-utenti",
    "/gestione-utenti",
    "/gestione-ticket",
    "/gestione-superpartner",
    "/gestione-agenzie",
    "/gestione-classi",
    "/gestione-sedi",
    "/gestione-certificazioni",
    "/gestione-contabilizzazioni",
    "/contabilizzazioni",
    "/assegna-corsi",
    "/gestione-corsi-utenti",
    "/blacklist-utenti",
    "/area-personale/invita-amico",
    "/rendicontazione",
    "/dashboard-rendicontazione-admin",
    "/archivio-rendicontazioni",
    "/vetrina-corsi",
    "/liquidazione-annuale",
    "/dashboard-rendicontazione-superpartner",
    "/archivio-rendicontazioni-superpartner",
  ];
  